"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fp = require("lodash/fp");

var _default = (0, _fp.curry)(function (array, value) {
  return (0, _fp.includes)(value)(array);
});

exports.default = _default;
//# sourceMappingURL=index.js.map